// extracted by mini-css-extract-plugin
export var modalFooter = "_py-0";